import { TokenizerAndRendererExtension, Tokens } from 'marked';

const calloutTypes = {
  tip: 'tip',
  note: 'note',
  warning: 'warning',
  example_given: 'example',
} as const;

const calloutTypesPattern = Object.keys(calloutTypes).join('|');

export const calloutBlockExtensions: TokenizerAndRendererExtension[] = [
  {
    name: 'calloutBlock',
    level: 'block',
    start(src: string) {
      // look for the opening tag of any callout type
      const regex = new RegExp(`<(${calloutTypesPattern})>`);
      const match = src.match(regex);
      return match ? src.indexOf(match[0]) : -1;
    },
    tokenizer(src: string) {
      const regex = new RegExp(`^<(${calloutTypesPattern})>([\\s\\S]*?)<\\/\\1>`);
      const match = src.match(regex);

      if (match) {
        const token = {
          type: 'calloutBlock',
          raw: match[0],
          text: match[2].trim(),
          blockType: match[1],
          tokens: [],
        };

        this.lexer.blockTokens(token.text, token.tokens);

        return token;
      }
      return undefined;
    },
    renderer(token: Tokens.Generic) {
      let innerHtml = '';

      if (token.tokens && token.tokens.length > 0) {
        innerHtml = this.parser.parse(token.tokens);
      } else {
        // fallback to raw text
        innerHtml = token['text'] || '';
      }

      const blockType = token['blockType'] as keyof typeof calloutTypes;
      const cssClass = calloutTypes[blockType] || 'note';

      return `<div class="example-block ${cssClass} not-prose"><div class="example-block-text not-prose">${innerHtml}</div></div>`;
    },
  },
];
